import { Risk, RiskClassCodeToRiskMap } from '../../types/policy';
import { RiskClassCode } from '../../types/risk';

export const getRiskByClassCode = <T extends RiskClassCode>(
  risks: Risk[],
  classCode: T
): RiskClassCodeToRiskMap[T] =>
  risks.find(({ riskClassCode }) => riskClassCode === classCode) as RiskClassCodeToRiskMap[T];
